import React, { useCallback, useContext, useEffect, useState } from 'react'
import { errorSchema, utils } from 'helper';
import { CityDropdownForTrip, CommonInput, CommonModal, CommonTextarea, CustomSelect, VehicleDropdownForTrip } from 'components'
import StorageService from 'utils/StorageServices/StorageServices';
import toast, { Toaster } from 'react-hot-toast';
import { createMaterialCategory } from '_services/materialServices/materialCategoryServices';
import { getAllVehicleNumber, podReceivedData, updateLrProcess, uploadFiles } from '_services';
import { RiAddLargeFill } from "react-icons/ri";
import { createZone } from '_services/accountsServices/zoneServices';
import { createVehicleGroup } from '_services/accountsServices/vehicleGroupServices';
import { createVehicleDocType, editVehicleDocType } from '_services/accountsServices/vehicleDocTypeServices';
import { createServiceRemainder, createStore, editStore, getItemsList } from '_services/workShopServices/workShopServices';
import './addEditServiceRemainder.css'
import { constant } from 'constants/constant';
import { DatePickerComponent } from 'components/common/CommonDatePicker';
import SingleSelectDropdownInfinite from 'components/common/SingleSelectDropdownInfinite/SingleSelectDropdownInfinite';
import WorkshopAddItem from 'modals/WorkshopAddItem';
import AddEditVehicleModal from 'modals/AddEditVehicleModal';
import AddEditOwnDriver from 'modals/AddEditOwnDriver';
import { UserContext } from 'context';

const formObj = {
    company_id: StorageService.getCompanyId(),
    vehicle_id: {},
    service_date: new Date(),
    odometer: "",
    reminder_date: "",
    reminder_kms: "",
    item_id: {},
    type: 1,
    remarks: "",
}

const AddEditServiceReminder = (props) => {

    const { isOpen, closeModal, nextModal, callListApi = () => { } } = props;
    const [formValue, setFormValue] = useState(formObj);
    const [formError, setFormError] = useState({});
    const [loading, setLoading] = useState(false);

    const [showAddItem, setShowAddItem] = useState(false);

    const [refreshVehicleDropdown, setRefreshVehicleDropdown] = useState(0);
    const [showOffcanvas, setShowOffcanvas] = useState(false);
    const [isDriver, setIsDriver] = useState(false);
    const [showOffcanvasOfDriver, setShowOffcanvasOfDriver] = useState(false);

    const { masterData } = useContext(UserContext);

    useEffect(() => {
        if (isOpen?.isDetails) {
            setFormValue((s) => ({
                ...s,
                company_id: isOpen?.company_id,
                name: isOpen?.name,
            }))
        }

    }, [isOpen?.isDetails])

    const handleOnChange = async (name, value) => {
        const stateObj = { ...formValue, [name]: value };
        let isAction = (stateObj?.item_id?.odometer_reading === 1) ? true : false;
        if (name === 'odometer') {
            stateObj['reminder_kms'] = isAction ? (Number(value) + Number(stateObj?.item_id?.odometer_kms)) : value;
        }
        if (name === 'type') {
            stateObj['item_id'] = {}
        }
        setFormValue(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, errorSchema.addEditServiceRemainderSchema);
            if (validationResult === true) {
                setFormError("");
            } else {
                setFormError(validationResult);
            }
        }
    };

    const apiCallingFunction = async () => {
        try {
            if (isOpen?._id) {
                let obj = {
                    ...formValue,
                    reminder_date: formValue.reminder_date ? utils.getTodayDate(formValue.reminder_date) : '',
                    item_id: formValue?.item_id?._id,
                    vehicle_id: formValue?.vehicle_id?._id,
                }
                delete obj.type;
                const res = await createServiceRemainder(obj);
                if (res?.responseCode == 200) {
                    setFormValue({});
                    setLoading(false);
                    if (res?.responseMessage) {
                        toast.success(res?.responseMessage);
                    }
                    closeModal(false);
                    callListApi();
                } else {
                    setLoading(false);
                    if (res?.responseMessage) {
                        toast.error(res?.responseMessage);
                    }
                }
            } else {
                let obj = {
                    ...formValue,
                    reminder_date: formValue.reminder_date ? utils.getTodayDate(formValue.reminder_date) : '',
                    item_id: formValue?.item_id?._id,
                    vehicle_id: formValue?.vehicle_id?._id,
                }
                delete obj.type;
                // delete obj.remarks;
                const res = await createServiceRemainder(obj);
                if (res?.responseCode == 200) {
                    setFormValue({});
                    setLoading(false);
                    if (res?.responseMessage) {
                        toast.success(res?.responseMessage);
                    }
                    closeModal(false);
                    callListApi();
                } else {
                    setLoading(false);
                    if (res?.responseMessage) {
                        toast.error(res?.responseMessage);
                    }
                }
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const handleClick = async (value) => {
        const validationResult = await utils?.checkFormError(formValue, errorSchema.addEditServiceRemainderSchema);
        if (utils?.isObjectKeyEmpty(validationResult)) {
            setLoading(true);
            apiCallingFunction();
            setFormError("");
        } else {
            setFormError(validationResult);
        }
    }

    useEffect(() => {
        if (isOpen?._id) {
            let isAction = (isOpen?.item?.time_interval === 1) ? 1 : 0
            let vehicleData = isOpen?.vehicle_id?.vehicle_no ? { ...isOpen?.vehicle_id, name: `${isOpen?.vehicle_id?.vehicle_no} | Own`, value: isOpen?.vehicle_id?._id } : { ...isOpen?.vehicle, name: `${isOpen?.vehicle?.vehicle_no} | Own`, value: isOpen?.vehicle?._id }
            setFormValue((s) => ({
                ...s,
                company_id: StorageService.getCompanyId(),
                vehicle_id: vehicleData,
                service_date: new Date(),
                item_id: { ...isOpen?.item, label: isOpen?.item.name, value: isOpen?.item._id },
                type: isOpen?.item?.type,
                reminder_date: isAction ? utils.getDateAfterDays(new Date(), isOpen?.item?.time_interval_days) : '',
            }))
        }
    }, [isOpen?._id])

    let inhanceProps = {
        ...props,
        submitTitle: loading ? 'Loading...' : props.submitTitle,
        disabled: loading,
        onSubmit: handleClick,
        modalZIndex: (showOffcanvas || showAddItem) ? 999 : ""
    }

    useEffect(() => {
        setFormValue((s) => ({
            ...s,
            company_id: StorageService.getCompanyId(),
        }))
    }, [])

    const fetchVehicle = async (search, page, limit) => {
        const res = await getAllVehicleNumber({
            company_id: StorageService.getCompanyId(),
            offset: page,
            limit,
            search,
            vehicle_ownership: [1, 3]
        });
        if (res?.responseCode === 200) {
            const list = res?.data?.vehicle_list?.map((i) => ({
                ...i,
                name: `${i?.vehicle_no}`,
                ownershipStatus: i?.vehicle_ownership,
            }));
            return {
                items: list,
                total: res?.data?.total_record,
            };
        } else {
            return { items: [], total: 0 };
        }
    };

    const handleVehicleChange = (data) => {
        setFormValue((prev) => ({
            ...prev,
            vehicle_id: data,
        }))

        if (formError.vehicle_id) {
            setFormError(prev => ({ ...prev, vehicle_id: {} }))
        }
    }

    const fetchItems = useCallback(async (search, page, limit) => {
        try {
            const response = await getItemsList({
                company_id: StorageService.getCompanyId(),
                offset: page,
                limit,
                search,
                type: formValue?.type,
                status: 1
            });

            if (response?.responseCode === 200) {
                const vendors = response.data.itemData.map(vendor => ({
                    ...vendor,
                    label: vendor.name,
                    value: vendor._id
                }));

                return {
                    items: vendors,
                    total: response.data.total_record || vendors.length,
                };
            }

            toast.error(response?.responseMessage);
            return { items: [], total: 0 };
        } catch (error) {
            return { items: [], total: 0 };
        }
    }, [formValue?.type]);

    const onhandleSelect = async (item, name) => {
        const stateObj = { ...formValue, [name]: item };
        if (name === 'item_id') {
            if (item?.odometer_reading === 1) {
                stateObj['reminder_kms'] = Number(stateObj?.odometer) + Number(item?.odometer_kms) // ((stateObj?.odometer > 0 ? +stateObj?.odometer : 0) + (+item?.odometer_kms));
            } else {
                stateObj['reminder_kms'] = stateObj?.odometer;
            }
            if (item?.time_interval === 1) {
                stateObj['reminder_date'] = utils.getDateAfterDays(new Date(), item?.time_interval_days);
            } else {
                stateObj['reminder_date'] = "";
            }
        }
        setFormValue(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, errorSchema.addEditServiceRemainderSchema);
            if (validationResult === true) {
                setFormError({});
            } else {
                setFormError(validationResult);
            }
        }
    };

    const addNewItemHandler = () => {
        setShowAddItem(true);
    }

    const addVehicleHandle = (data) => {
        setShowOffcanvas(true);
    };

    const callBackVehicle = async (data) => {
        onhandleSelect({
            ...data,
            name: data.vehicle_no,
            label: `${data.vehicle_no} | ${masterData?.vehicle_ownership[data?.vehicle_ownership]}`,
        }, 'vehicle_id')
        // setFormValue((pre) => ({
        //     ...pre, vehicle_id: {
        //         ...data,
        //         label: `${data.vehicle_no} | ${masterData?.vehicle_ownership[data?.vehicle_ownership]}`,
        //     },
        // }))
        setTimeout(() => {
            setRefreshVehicleDropdown(prev => prev + 1);
        }, 2000);
    };

    const handleAddNewVehicleButtonAction = () => {
        setIsDriver(false);
        setShowOffcanvasOfDriver(true);
    };

    const handleDriverNextModal = () => {
        setIsDriver(!isDriver);
        setShowOffcanvas(true);
    };

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return (
        <div>
            <CommonModal {...inhanceProps}>
                <div className='addItem_body __addServRemind mt-2'>
                    <div className='colFlx'>
                        <div className='halfDiv'>
                            {/* <SingleSelectDropdownInfinite
                                placeholder="Vehicle Number"
                                fetchData={fetchVehicle}
                                selectedItem={formValue?.vehicle_id}
                                onChange={(data) => onhandleSelect(data, 'vehicle_id')}
                                loadOnOpen={true}
                                error={formError['vehicle_id.name']}
                                errorMessage={formError['vehicle_id.name']}
                            /> */}
                            <VehicleDropdownForTrip
                                label='Vehicle Number'
                                placeholder="Vehicle Number"
                                fetchData={fetchVehicle}
                                selectedItem={formValue?.vehicle_id}
                                onChange={(data) => onhandleSelect(data, 'vehicle_id')}
                                loadOnOpen={true}
                                error={formError['vehicle_id.name']}
                                errorMessage={formError['vehicle_id.name']}

                                isAddButton={true}
                                addButtonAction={(e) => addVehicleHandle(e)}
                                pageSize={7}
                                refreshTrigger={refreshVehicleDropdown}
                            />
                        </div>
                        <div className='singleDiv'>
                            <CommonInput
                                type="text"
                                label='Fleet Odometer Reading'
                                placeholder='Fleet Odometer Reading'
                                name='odometer'
                                value={formValue.odometer}
                                disabled={isOpen?.isDetails ? true : false}
                                focus={!!(typeof formError === "object" && formError?.odometer)}
                                error={!!(typeof formError === "object") ? formError?.odometer : ""}
                                maxLength="6"
                                onInput={utils.maxLengthCheck}
                                onChange={(e) => utils.withoutDotLettersSpaceSpecialCharacters(e, handleOnChange)}
                            />
                        </div>

                        <div className="singleDiv">
                            <div className="_payMode_hed">
                                <h4> Select Service Type </h4>

                                <div className='checkBx_lv p-0 mt-0' style={{ width: '100%' }}>
                                    {
                                        constant.isServiceType?.map((el, ind) => {
                                            return (
                                                <React.Fragment key={ind}>
                                                    <div className='_dualCheckr_bx mt-2' style={{ maxWidth: '85px', width: '100%' }}>
                                                        <input
                                                            style={{ marginTop: '2px' }}
                                                            className="form-check-input"
                                                            id={+ind + "type" + el?.value}
                                                            type="radio"
                                                            name="type"
                                                            checked={formValue?.type === el?.value}
                                                            value={el?.value}
                                                            onChange={(e) => handleOnChange('type', el?.value)}
                                                        />
                                                        <label style={{ fontSize: '14px' }} htmlFor={+ind + "type" + el.value} className="form-check-label" >
                                                            {el.label}
                                                        </label>
                                                    </div>
                                                </React.Fragment>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>

                        <div className='singleDiv'>
                            <CityDropdownForTrip
                                label={formValue?.type === 1 ? "Select Item" : "Select Services"}
                                placeholder={formValue?.type === 1 ? "Select Item" : "Select Services"}
                                fetchData={fetchItems}
                                pageSize={20}
                                disabled={isOpen?.isDetails ? true : false}
                                selectedItem={formValue.item_id ? formValue?.item_id : null}
                                onChange={(data) => onhandleSelect(data, 'item_id')}
                                error={formError['item_id.label']}
                                errorMessage={formError['item_id.label']}
                                isAddButton={true}
                                addButtonAction={(e) => addNewItemHandler(e)}
                            />
                        </div>

                        <div className='singleDiv'>
                            <CommonTextarea
                                type="textarea"
                                label='Remarks'
                                placeholder='Remarks'
                                name='remarks'
                                value={formValue.remarks}
                                // disabled={isOpen?._id ? true : (isOpen?.isDetails ? true : false)}
                                focus={!!(typeof formError === "object" && formError?.remarks)}
                                error={!!(typeof formError === "object") ? formError?.remarks : ""}
                                maxLength="500"
                                onInput={utils.maxLengthCheck}
                                onChange={({ target: { name, value } }) =>
                                    handleOnChange(name, value)
                                }
                            />
                        </div>

                        <div className='singleDiv'>
                            <DatePickerComponent
                                label="Reminder Date "
                                name="reminder_date"
                                showTimeSelect={false}
                                defaultTimeFix={false}
                                min={today}
                                startDate={formValue?.reminder_date}
                                onChange={(data) => handleOnChange('reminder_date', data)}
                                error={!!(typeof formError === "object") ? formError?.reminder_date : ""}
                            />
                        </div>

                        <div className='singleDiv'>
                            <CommonInput
                                type="text"
                                label='Due at KMs'
                                placeholder='Due at KMs'
                                name='reminder_kms'
                                value={formValue.reminder_kms}
                                disabled={true}
                                focus={!!(typeof formError === "object" && formError?.reminder_kms)}
                                error={!!(typeof formError === "object") ? formError?.reminder_kms : ""}
                                maxLength="6"
                                onInput={utils.maxLengthCheck}
                                onChange={(e) => utils.withoutDotLettersSpaceSpecialCharacters(e, handleOnChange)}
                            />
                        </div>
                    </div>
                </div>
            </CommonModal>
            {/* <div className='offBack_drop'></div> */}

            <div
                className={`offcanvas offcanvas-end common_offCanvas mdOffcanvas ${showAddItem ? "show" : ""}`}
                tabIndex={-1}
                style={{ visibility: showAddItem ? "visible" : "hidden" }}
            >
                {showAddItem && (
                    <WorkshopAddItem
                        isOpen={showAddItem}
                        onClose={(e) => setShowAddItem(false)}
                        showExpenseTypeDisable={true}
                        expenseType={formValue?.type}
                        getDataCallBack={(data) => onhandleSelect({ ...data, label: data?.name, value: data?._id }, 'item_id')} // setFormValue((s) => ({ ...s, item_id: { label: data?.name, value: data?._id } }))}
                    />
                )}
            </div>
            <div className={showAddItem ? "offBack_drop" : ""}></div>

            {/* Vehicle Modal */}
            <div
                className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvas ? "show" : ""
                    }`}
                tabIndex={-1}
                style={{ visibility: showOffcanvas ? "visible" : "hidden" }}
            >
                {showOffcanvas && (
                    <AddEditVehicleModal
                        isOpen={showOffcanvas}
                        onClose={() => setShowOffcanvas(false)}
                        callBackVehicle={callBackVehicle}
                        isDriver={isDriver}
                        handleAddNewVehicleButtonAction={
                            handleAddNewVehicleButtonAction
                        }
                        showOnlyOwn_Leased={false}
                        hideAddNewOption={false}
                    />
                )}
            </div>
            <div className={showOffcanvas ? "offBack_drop" : ""}></div>

            <div
                className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvasOfDriver ? "show" : ""
                    }`}
                tabIndex={-1}
                style={{ visibility: showOffcanvasOfDriver ? "visible" : "hidden" }}
            >
                {showOffcanvasOfDriver && (
                    <AddEditOwnDriver
                        isOpen={showOffcanvasOfDriver}
                        onClose={() => setShowOffcanvasOfDriver(false)}
                        callBackDriver={(e) => handleDriverNextModal(e)}
                        hideAddNewOption={false}
                    />
                )}
            </div>
            <div className={showOffcanvasOfDriver ? "offBack_drop" : ""}></div>

        </div>
    )
}

export default AddEditServiceReminder